<template>
    <section ref='filtersWrapper' :class="['parametric-filters', {'is-open': isFilterOpen}]">
        <div ref='filtersInner' class="parametric-filters__wrapper">
            <div v-if="isMobile" class="parametric-filters__head">
                <button @click="$emit('close')" class="button parametric-filters__close">
                    <CloseFilterIcon />
                </button>

                <div class="parametric-filters__title">Фильтр</div>

                <button
                    class="button parametric-filters__clear"
                    @click="reset">
                    <ResetFilterIcon />
                </button>
            </div>

            <form
                :class="['parametric-filters__form', {'is-processing': isProc}]"
                ref="form"
                @change="change"
                @reset.prevent="reset">

                <div class="parametric-filters__content-main">
                    <div v-if="isEstateFlat" class="parametric-filters__group parametric-filters__rooms">
                        <div class="parametric-filters__group-label">
                            Количество комнат
                        </div>
                        <ul class="parametric-filters__rooms-list">
                            <li v-for="item in filters.room" :key="item.id">
                                <ButtonCheckbox
                                    modify="button-checkbox_theme_parametric parametric-filters__checkbox"
                                    :name="`room[${item.id}]`"
                                    :checked="item.checked"
                                    :disabled="item.disabled"
                                    :value="item.title"
                                />
                            </li>
                        </ul>
                    </div>
                    <div v-else class="parametric-filters__group parametric-filters__rooms">
                        <Select
                            :building="building"
                            @selectric-select="selectrichange($event)"
                            ref='buildingWrapper'
                            :modify="'parametric-filters__select'"
                        />
                        <div class="parametric-filters__button-wrapper">
                            <button
                                type="button"
                                class="button parametric-filters__button-gen-plan"
                                @click.prevent="$emit('openModal')"
                            >
                                <Mark />
                                <span>Выбрать корпус на генплане</span>
                            </button>
                        </div>
                    </div>
                    <div v-if="!hiddenPrices" class="parametric-filters__group parametric-filters__price">
                        <div class="parametric-filters__group-label">
                            Стоимость {{ isEstateFlat ? 'апартаментов' : 'помещений' }}<br>
                            с&nbsp;полной чистовой отделкой, руб.
                        </div>
                        <Slider
                            :name="'price'"
                            :to="sliders.price.to"
                            :from="sliders.price.from"
                            :modify="'test'"
                            ref="sliderPrice"/>
                    </div>
                    <div class="parametric-filters__group parametric-filters__square">
                        <div class="parametric-filters__group-label">Площадь, м²</div>
                        <Slider
                            :name="'area'"
                            :to="sliders.area.to"
                            :from="sliders.area.from"
                            ref="sliderArea"/>
                    </div>

                    <div class="parametric-filters__group parametric-filters__queue">
                            <div class="parametric-filters__group-label">Очередь</div>
                            <div class="parametric-filters__group-options">
                                <div class="parametric-filters__queue-list">
                                    <ButtonCheckbox
                                        v-for="item in filters.delivery" :key="item.id"
                                        modify="button-checkbox_theme_parametric"
                                        :name="`delivery[${item.id}]`"
                                        :checked="item.checked"
                                        :disabled="item.disabled"
                                        :value="item.label"
                                        :time="item.title"
                                    />
                                </div>
                            </div>
                        </div>
                </div>

                <transition name="fade">
                    <div v-show="isMobile || isExtendedShow"
                    class="parametric-filters__content-extended">
                        <div
                            v-if="isEstateFlat"
                            class="parametric-filters__group parametric-filters__floors">
                            <div class="parametric-filters__group-label">Этаж</div>
                            <Slider
                                :name="'floors'"
                                :to="sliders.floors.to"
                                :from="sliders.floors.from"
                                ref="sliderFloors"/>
                        </div>

                        <div class="parametric-filters__group parametric-filters__options">
                            <div class="parametric-filters__group-label">Особенности</div>
                            <div v-if="isEstateFlat" class="parametric-filters__group-options">
                                <ul class="parametric-filters__options-list">
                                    <li v-for="item in filters.option" :key="item.id">
                                        <ButtonCheckbox
                                            modify="button-checkbox_theme_parametric"
                                            :name="`option[${item.id}]`"
                                            :checked="item.checked"
                                            :disabled="item.disabled"
                                            :value="item.title"
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </transition>

                <div v-if="!isMobile" class="parametric-filters__buttons">
                    <button
                        :class="['button parametric-filters__button-extended', {'is-open': isExtendedShow}]"
                        @click.prevent="expandExtended"
                    >
                        <span class="button__icon">
                            <ExpandArrowIcon />
                        </span>
                        {{ isExtendedShow ? 'Простой фильтр' : 'Расширенный фильтр' }}
                    </button>

                    <button
                        type="reset"
                        class="button parametric-filters__form-reset"
                    >
                        <span>Сбросить фильтр</span>
                        <div class="button__icon">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5"
                                    stroke="#002436"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </button>
                </div>
            </form>
            <button
                v-if="isMobile"
                class="button button_theme_parametric button_theme_black parametric-filters__show"
                @click="$emit('close')">
                Показать {{ flats.length }} {{ word() }}
            </button>
        </div>
    </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import ButtonCheckbox from 'components/button-checkbox/ButtonCheckbox.vue';
import CloseFilterIcon from '../svg-media/CloseFilter.vue';
import ExpandArrowIcon from '../svg-media/ExpandArrow.vue';
import initSliders from 'components/range-slider/config/param';
import Mark from '../svg-media/mark.vue';
import Observer from 'common/scripts/observer';
import ResetFilterIcon from '../svg-media/ResetFilter.vue';

import Select from 'components/forms/select/select-vue.vue';
import Slider from 'components/range-slider/range-slider.vue';

import Utils from 'common/scripts/utils';

const observer = new Observer();
const header = document.querySelector('.j-header');

export default {
    data() {
        return {
            isExtendedShow: false
        };
    },

    props: ['isFilterOpen'],

    components: {
        ButtonCheckbox,
        CloseFilterIcon,
        ExpandArrowIcon,
        Mark,
        Select,
        Slider,
        ResetFilterIcon
    },

    computed: {
        ...mapGetters({
            isReady     : 'GET_IS_READY',
            isProc      : 'GET_IS_PROCESSING',
            sliders     : 'GET_SLIDERS',
            building    : 'GET_BUILDING',
            filters     : 'GET_FILTERS',
            page        : 'GET_PAGE',
            estateType  : 'GET_ESTATETYPE',
            hiddenPrices: 'GET_HIDDENPRICES',
            isMobile    : 'GET_IS_MOBILE',
            flats       : 'GET_FLATS'
        }),

        isEstateFlat() {
            return this.estateType === 1;
        }
    },

    watch: {
        isReady() {
            this.$nextTick(() => {
                initSliders(this.$refs, this.sliders);
                this.initFilter({form: this.$refs.form});
                this.buildingList = {...this.building};
            });
        },

        sliders() {
            this.$nextTick(() => {
                observer.publish('parametricfilterUpdate');
                this.updateFilter();
            });
        },

        isFilterOpen() {
            if (this.isFilterOpen) {
                observer.publish('parametricfilterOpen', this.$refs.filtersWrapper);

                if (header) {
                    header.classList.add('is-zero');
                }

                Utils.bodyFixed(this.$el);
            } else {
                observer.publish('parametricfilterClose', this.$refs.filtersWrapper);

                if (header) {
                    header.classList.remove('is-zero');
                }

                Utils.bodyStatic();
            }
        }
    },

    mounted() {
        this.subscribes();
    },

    methods: {
        ...mapActions(['initFilter', 'changeFilter', 'resetFilter', 'updateFilter', 'updateBuildings']),

        subscribes() {
            observer.subscribe('rangesliderFinish', () => {
                this.change();
            });
        },

        change() {
            const body = {
                type: 'filter',
                form: this.$refs.form
            };

            this.changeFilter(body);
        },

        reset() {
            $('#buildingSelection')
                .find('option:first-child')
                .prop('selected', true)
                .end()
                .trigger('chosen:updated')
                .change(() => {
                    this.$emit('selectChange');
                });
            this.resetFilter({type: 'reset'});
        },

        selectrichange() {
            this.change();
        },

        openModal() {
            this.$emit('openModal');
        },

        word() {
            const wordArray = this.isEstateFlat ?
                ['апартамент', 'апартамента', 'апартаментов'] :
                ['помещение', 'помещения', 'помещений'];

            return Utils.pluralWord(this.borderShow, wordArray);
        },

        expandExtended() {
            this.isExtendedShow = !this.isExtendedShow;
        }
    }
};
</script>
